import { Recommendation } from "../types/recommendations";

export const recommendations: Recommendation[] = [
  {
    id: 0,
    author: "Mike Keegan",
    position: "Head of R&D at Ei Electronics",
    date: "January 25, 2025",
    relationship: "Mike worked with Sam but at different companies",
    content: "Sam thrives in high-pressure, rapidly changing environments, whether pioneering IoT systems or scaling infrastructure to handle rapidly growing demands. His considerable and varied experience, along with deep & current technical knowledge, enable him to architect, design & rapidly develop solutions. \n\nSpecialties include traditional and emerging databases, complex back-end queueing & data routing, as well as user-focussed UIs.\n\nSam has the ability to balance immediate business drivers (we need it now!) and longer-term architectural imperatives (we’ll need to grow & maintain this for the next 10 years!). Sam’s a clear communicator at all levels, from the application users through the team/projects management and up to the C-level.\n\nSam’s genuine passion for technology and innovation makes him a driving force in any organization. His enthusiasm is contagious, fostering a culture of curiosity and continuous improvement.",
    image: "mike"
  },
  {
    id: 1,
    author: "Chris Jones",
    position: "CEO at HomeLINK",
    date: "April 15, 2024",
    relationship: "Chris managed Sam directly",
    content: "I had the privilege of collaborating closely with Sam, who was not only our Chief Technology Officer but also a cornerstone of our organisation. Sam's tenure with us was marked by extraordinary commitment and a profound passion for our mission in the smart home technology space, specifically within the UK's social housing sector.\n\nSam's exceptional proficiency in software development was pivotal in creating the foundational architecture of our platform. His technical acumen enabled us to translate complex requirements into robust and scalable software solutions. Sam was genuinely passionate about software development, often working extended hours to meet our ambitious objectives, which greatly accelerated our progress and set new industry standards.\n\nI wholeheartedly endorse Sam for any leadership role involving technology and innovation. His deep understanding of software, commitment to excellence, and foundational impact on our company make him an invaluable asset to any technology lead organisation.",
    image: "chris"
  },
  {
    id: 2,
    author: "Harvey Gilbert",
    position: "Director & Vice Chairman at SCAA Causeway Bay RFC",
    date: "August 21, 2017",
    relationship: "Harvey managed Sam directly",
    content: "Sam is a leader, thinker, innovator and deliverer of high quality, robust, contemporary technology solutions. Sam is passionate, intelligent and determined to really understand the business problem in order to plan and build the optimal technology that delivers results above and beyond expectations.",
    image: "harvey",
    printPageTop: true
  },
  {
    id: 3,
    author: "Richard Carver",
    position: "Transformation Director at Datny Group",
    date: "December 21, 2012",
    relationship: "Richard was Sam's client",
    content: "Sam finds innovative solutions to complex software problems and is adept at communicating to both technical and non-technical clients and colleagues.",
    image: "richard"
  },
  {
    id: 4,
    author: "Hayley Parsons OBE",
    position: "Non Executive Director at Cardiff Rugby",
    date: "December 13, 2012",
    relationship: "Hayley was Sam's client",
    content: "Sam worked with us at Gocompare.com for 9 months and added great value to our IT department. I was sad to see Sam move on and would strongly recommend Sam as a great addition to any business. A lively guy and a pleasure to work with.",
    image: "hayley",
    printPageTop: true
  },
  {
    id: 6,
    author: "Peter Clarke",
    position: "Semi Retired",
    date: "December 22, 2011",
    relationship: "Peter managed Sam directly",
    content: "Sam is a highly skilled and hard working developer and IT professional, and is the kind of person who will get on well in any team. Quick to assimilate new technologies and to share his technical expertise with the team. Never too busy to answer a question or to help others; he always gets the job done. I wouldn't hesitate in recommending Sam to any prospective employer.",
    image: "peter"
  },
  {
    id: 7,
    author: "Steve Wilkes",
    position: "Director and Principal Engineer at AgileObjects Ltd",
    date: "December 8, 2011",
    relationship: "Steve worked with Sam on the same team",
    content: "Of all the developers I've worked with in my ten years of programming, Sam is the most capable. He quickly grasps new topics and complex techniques, writes well-structured, easy-to-maintain code, and can be trusted to take ownership of business-critical projects. I genuinely cannot recommend Sam highly enough.",
    image: "steve"
  }

];